import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const dark = window.matchMedia?.('(prefers-color-scheme: dark)').matches

export default new Vuetify({
  theme: {
    dark,
    themes: {
      light: {
        primary:    '#6B7FA3',
        secondary:  '#8B6914',
        accent:     '#C4A35A',
        background: '#e8e8e8',
        surface:    '#f4f4f4',
        error:      '#B00020',
        info:       '#7B9EB8',
        success:    '#5A7A5A',
        warning:    '#C17F24',
      },
      dark: {
        primary:    '#8FA8C8',
        secondary:  '#C4A35A',
        accent:     '#D4A017',
        background: '#1A1812',
        surface:    '#252018',
        error:      '#CF6679',
        info:       '#7B9EB8',
        success:    '#7AAD7A',
        warning:    '#E09A3A',
      }
    }
  }
})